export const AUTH_RESET = 'AUTH_RESET';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';

export const AUTH_CLEAN = 'AUTH_CLEAN';

// Boot-time "is there already a valid session cookie" check - kept distinct
// from AUTH_START/FAILURE since a failed check is a silent logged-out state,
// not a login-form error.
export const AUTH_CHECK_START = 'AUTH_CHECK_START';
export const AUTH_CHECK_SUCCESS = 'AUTH_CHECK_SUCCESS';
export const AUTH_CHECK_FAILURE = 'AUTH_CHECK_FAILURE';
